import { render, staticRenderFns } from "./rms-objects-orders-tab.vue?vue&type=template&id=66e8e4d4&scoped=true"
import script from "./rms-objects-orders-tab.vue?vue&type=script&lang=js"
export * from "./rms-objects-orders-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8e4d4",
  null
  
)

export default component.exports